(function () {
  let _menuOpen = false;
  let _isMobile = false;
  let _query = getURLParameters();
  function main() {
    if (window.innerWidth >= 768) {
      // 在PC端加载大图
      initPCWeb();
    } else {
      // 在移动端加载小图
      initH5();
    }
    bindMenu();
    initSwiper();
    if (
      _query.page &&
      ["product", "industries", "company"].includes(_query.page)
    ) {
      showPage(_query.page);
    }
  }
  main();

  function initPCWeb() {}

  function initH5() {
    _isMobile = true;
    const menu = document.querySelector(".PhoneHeader-menu-content");

    menu.addEventListener("click", () => {
      if (_menuOpen) {
        closeH5Menu();
      } else {
        _menuOpen = true;
        document.querySelector(".hesai-PhoneHeader").classList.add("white-bg");
        document
          .querySelector(".PhoneHeader-menu-content")
          .classList.add("open");
        document.querySelector(".PhoneHeader-nav").classList.add("unfold");
      }
    });
  }

  function closeH5Menu() {
    _menuOpen = false;
    document.querySelector(".hesai-PhoneHeader").classList.remove("white-bg");
    document
      .querySelector(".PhoneHeader-menu-content")
      .classList.remove("open");
    document.querySelector(".PhoneHeader-nav").classList.remove("unfold");
  }

  function bindMenu() {
    // 获取nav-item 添加点击事件
    const navItems = document.querySelectorAll(".nav-item");
    navItems.forEach((item) => {
      item.addEventListener("click", (e) => {
        if (_isMobile) {
          closeH5Menu();
        }

        showPage(e.target.dataset.page);
        // 滚动到顶部
        document.documentElement.scrollTop = 0;
      });
    });
  }

  function showPage(page) {
    const navItems = document.querySelectorAll(".nav-item");
    navItems.forEach((item) => {
      if (item.attributes["data-page"].value == page) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });

    document.querySelectorAll(".page").forEach((item) => {
      item.classList.add("hide");
    });
    document.querySelector(`.${page}`).classList.remove("hide");
  }

  function initSwiper() {
    new Swiper(".swiper1", {
      direction: "horizontal",
      autoHeight: true,
      loop: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
      },

      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // 如果需要滚动条
      scrollbar: {
        el: ".swiper-scrollbar",
      },
    });
    if (_isMobile) {
      const swiper2BottomImgs = document.querySelectorAll(
        ".swiper2-bottom-img"
      );
      let currentImageIndex = 0;
      new Swiper(".swiper2", {
        direction: "horizontal",
        autoHeight: true,
        loop: true,
        autoplay: false,
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
        },

        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        // 如果需要滚动条
        scrollbar: {
          el: ".swiper-scrollbar",
        },

        // 切换
        on: {
          slidePrevTransitionStart: function () {
            
            swiper2BottomImgs[currentImageIndex].classList.remove("image-show");
            if (currentImageIndex == 0) {
              currentImageIndex = swiper2BottomImgs.length - 1;
            } else {
              currentImageIndex--;
            }
            swiper2BottomImgs[currentImageIndex].classList.add("image-show");
          },
          slideNextTransitionStart: function () {
            swiper2BottomImgs[currentImageIndex].classList.remove("image-show");
            if (currentImageIndex == swiper2BottomImgs.length - 1) {
              currentImageIndex = 0;
            } else {
              currentImageIndex++;
            }
            swiper2BottomImgs[currentImageIndex].classList.add("image-show");
          },
        },
      });
    }
  }

  const navbar = document.querySelector(".navbar");

  // 监听滚动
  window.addEventListener("scroll", function () {
    const activeNavItem = document.querySelector(".nav-item.active");
    // 获取滚动条滚动的距离
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    // 滚动的高度大于 navbar 高度
    if (scrollTop > navbar.offsetHeight) {
      navbar.classList.add("filter");
      activeNavItem.classList.add("filter");
    } else {
      navbar.classList.remove("filter");
      activeNavItem.classList.remove("filter");
    }
  });

  function getURLParameters() {
    var params = {};
    var queryString = window.location.search.slice(1);

    if (queryString) {
      var keyValuePairs = queryString.split("&");
      for (var i = 0; i < keyValuePairs.length; i++) {
        var keyValuePair = keyValuePairs[i].split("=");
        var key = decodeURIComponent(keyValuePair[0]);
        var value = decodeURIComponent(keyValuePair[1] || "");
        params[key] = value;
      }
    }

    return params;
  }
})();
